exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-item[data-v-577e71c3]{margin-bottom:20px}.pagination[data-v-577e71c3]{margin-top:20px;text-align:center}.add-content-wrapper[data-v-577e71c3]{height:128px;width:100%}.add-content-wrapper .add-content[data-v-577e71c3]{text-align:center;line-height:128px;font-size:16px;cursor:pointer;color:#2a82e4;display:block}", ""]);

// exports
